<template>
  <div>

    <h1>Associar Perfil</h1>

    <div class="container-dados-usuario pb-2 pl-1" v-if="!loadingUsuariosPerfis && listaDadosAssociados.length || listaDadosDisponiveis.length">

      <h5>Usuário: <small> {{ usuarioPerfil.name }}</small></h5>
      <h5>Login: <small> {{ usuarioPerfil.login }}</small></h5>
    </div>

    <SGPAlertaComponent v-else />

    <SGPAssociarComponent
      v-if="listaDadosAssociados.length || listaDadosDisponiveis.length"
      tituloAssociados="Perfis"
      tituloDisponiveis="Perfis"
      :dadoAssociado="listaDadosAssociados"
      :dadoDisponivel="listaDadosDisponiveis"
      @sgpSalvarAssociacoesEmit="perfisParaAssociar"
    />

    <SGPLoadingComponent v-if="loadingUsuariosPerfis" />
    
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import FormularioUsuarioPerfilComponent from '../components/FormularioUsuarioPerfilComponent.vue'

export default {
  // components: { FormularioUsuarioPerfilComponent },
  name: 'UsuarioPerfilAssociacaoPage',

  data () {
    return {
      listaDadosAssociados: [],
      listaDadosDisponiveis: []
    }
  },

  async created () {
    await this.listarPerfis()
    await this.recuperarUsuarioComPerfis(this.$route.params.usuario)

    this.atualizarListaDeDadosAssociadosENaoAssociados()
  },

  computed: {
    ...mapGetters('usuariosPerfis', ['loadingUsuariosPerfis', 'listaPerfis', 'usuarioSelecionadoComPerfis']),

    usuarioPerfil () {
      return this.usuarioSelecionadoComPerfis
    },

    perfisAssociados () {      
      return this.usuarioSelecionadoComPerfis.roles.map(role => {
        return {
          id: role.id,
          descricao: role.description,
          selecionado: false
        }
      })    
    },

    perfisDisponiveis () {
      const listaDePerfisAssociados = this.usuarioSelecionadoComPerfis.roles.map(role => role.id)

      return this.listaPerfis.filter(perfil => !listaDePerfisAssociados.includes(perfil.id))
        .map(perfil => {
          return {
            id: perfil.id,
            descricao: perfil.description,
            selecionado: false
          }
        })
    }
  },

  methods: {
    ...mapActions('usuarios', [ 'listarUsuarios', 'recuperarUsuario' ]),
    ...mapActions('usuariosPerfis', [
      'listarPerfis',
      'recuperarUsuarioComPerfis',
      'associarPerfisAoUsuario'
    ]),

    atualizarListaDeDadosAssociadosENaoAssociados () {
      this.listaDadosAssociados = this.perfisAssociados
      this.listaDadosDisponiveis = this.perfisDisponiveis
    },

    perfisParaAssociar (value) {
      const listaIdsAssociados = value.listaAssociados.map(perfil => perfil.id)

      const payload = {
        usuarioId: this.$route.params.usuario,
        roles: listaIdsAssociados
      }

      this.associarPerfisAoUsuario(payload)
    }
  }

}
</script>
